import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';

interface FinalStepProps {
  onNext: () => void;
}

export function FinalStep({ onNext }: FinalStepProps) {
  return (
    <div className="space-y-8">
      <div className="text-center space-y-4">
        <div className="flex justify-center">
          <div className="relative">
            <Sparkles className="w-12 h-12 text-primary animate-pulse" />
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
          </div>
        </div>
        <h3 className="text-2xl font-bold">You're All Set!</h3>
        <p className="text-muted-foreground">
          Your personalized health and fitness journey begins now
        </p>
      </div>

      <div className="theme-card p-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
        <div className="relative space-y-4">
          <h4 className="font-semibold">What's Next?</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Track your daily metrics</span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Get personalized recommendations</span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Optimize your performance</span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm">Achieve your fitness goals</span>
            </li>
          </ul>
        </div>
      </div>

      <button
        onClick={onNext}
        className="w-full theme-button py-3 rounded-lg flex items-center justify-center gap-2"
      >
        Get Started
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}